import { Component }         from '@angular/core';
import { NavController }     from 'ionic-angular';
import { MenuController }    from 'ionic-angular';

import { KeyPoint }       from '../../shared/models/keypoint';
import { NavParams }      from 'ionic-angular';
import { GoogleAnalytics } from '@ionic-native/google-analytics';

@Component({
  selector: 'page-key-point-detail',
  templateUrl: 'key-point-detail.html'
})

export class KeyPointDetailPage
{
  keyPoint        : KeyPoint = null;
  keyPointContent : string   = "";
  origItemName    : string   = null;

  constructor(public navCtrl   : NavController ,
              public navParams : NavParams,
              public menuCtrl  : MenuController,
              private analytics  : GoogleAnalytics)
  {
    this.origItemName    = this.navParams.get('origItemName');
    this.keyPoint        = this.navParams.get('selItem');
    this.keyPointContent = this.keyPoint.Content.replace(/\n/g, '<br \/>');
  }

  ionViewDidLoad() // #3794
  {
    this.analytics.trackView("Key Points detail " + this.origItemName);
  }

  toggleMenu()
  {
    this.menuCtrl.toggle();
  }

  backAction()
  {
    this.navCtrl.pop({animate: false});
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/key-point-detail/key-point-detail.ts